<template>
  <div class="income-box">
    <hshead title="店铺收益" waveBg="true"></hshead>
    <div class="income-time-select">
      <div class="this-time" @click="show=true">
        2018年5月
        <span>
          <img src="../assets/images/income/arr.png" alt />
        </span>
      </div>
    </div>
    <div class="income-top">
      <div class="top-left">
        <div class="this-p">已通过：10</div>
        <div class="this-p">审核中：2</div>
        <div class="this-p">审核中：2</div>
      </div>
      <div class="top-right">
        <div class="this-img">
          <img src="../assets/images/income/wallet-w.png" alt />
        </div>
        <router-link to class="this-btn">我要提现</router-link>
      </div>
    </div>
    <div class="income-tab">
      <van-tabs v-model="tabactive" swipeable title-active-color="#007dfa" color="#007dfa">
        <van-tab title="收益明细">
          <div class="income-ul">
            <div class="income-li">
              <div class="left-img">
                <img src="../assets/images/income/wallet.png" alt />
              </div>
              <div class="center-p-box">
                <div class="center-p">订单号：10001</div>
                <div class="center-p">收益：￥1000</div>
                <div class="center-p">收益时间：2018-05-01 22:36</div>
              </div>
              <div class="right-img">
                <img src="../assets/images/income/icon.png" alt />
              </div>
            </div>
            <div class="income-li">
              <div class="left-img">
                <img src="../assets/images/income/wallet.png" alt />
              </div>
              <div class="center-p-box">
                <div class="center-p">订单号：10001</div>
                <div class="center-p">收益：￥1000</div>
                <div class="center-p">收益时间：2018-05-01 22:36</div>
              </div>
              <div class="right-img">
                <img src="../assets/images/income/icon.png" alt />
              </div>
            </div>
            <div class="income-li">
              <div class="left-img">
                <img src="../assets/images/income/wallet.png" alt />
              </div>
              <div class="center-p-box">
                <div class="center-p">订单号：10001</div>
                <div class="center-p">收益：￥1000</div>
                <div class="center-p">收益时间：2018-05-01 22:36</div>
              </div>
              <div class="right-img">
                <img src="../assets/images/income/icon.png" alt />
              </div>
            </div>
            <div class="income-li">
              <div class="left-img">
                <img src="../assets/images/income/wallet.png" alt />
              </div>
              <div class="center-p-box">
                <div class="center-p">订单号：10001</div>
                <div class="center-p">收益：￥1000</div>
                <div class="center-p">收益时间：2018-05-01 22:36</div>
              </div>
              <div class="right-img">
                <img src="../assets/images/income/icon.png" alt />
              </div>
            </div>
          </div>
        </van-tab>
        <van-tab title="结算中">内容 2</van-tab>
        <van-tab title="提现明细">内容 3</van-tab>
      </van-tabs>
    </div>
    <van-tabbar v-model="active">
      <van-tabbar-item to="/MissionHall" icon="todo-list-o">任务中心</van-tabbar-item>
      <van-tabbar-item icon="chart-trending-o">收益</van-tabbar-item>
      <van-tabbar-item icon="manager-o">摄影师</van-tabbar-item>
      <van-tabbar-item icon="orders-o">商品管理</van-tabbar-item>
      <van-tabbar-item icon="apps-o">更多</van-tabbar-item>
    </van-tabbar>
    <van-popup v-model="show" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="year-month"
        :formatter="formatter"
        @cancel="show=false"
        @confirm="show=false;searchTime = currentDate"
      />
    </van-popup>
  </div>
</template>

<script>
import hshead from "@/components/common/hshead";
import { DatetimePicker, Popup, Tab, Tabs, Tabbar, TabbarItem } from "vant";
export default {
  name: "income",
  data() {
    return {
      tabactive: 0,
      active: 1,
      show: false,
      searchTime: new Date(), // 拿到的修改后的日期，去watch获取数据就行
      currentDate: new Date()
    };
  },
  methods: {
    formatter(type, value) {
      if (type === "year") {
        return `${value}年`;
      } else if (type === "month") {
        return `${value}月`;
      }
      return value;
    }
  },
  components: {
    hshead,
    "van-datetime-picker": DatetimePicker,
    "van-popup": Popup,
    "van-tabs": Tabs,
    "van-tab": Tab,
    "van-tabbar": Tabbar,
    "van-tabbar-item": TabbarItem
  }
};
</script>

<style lang="less" scoped>
@import "../assets/less/common.less";
@import "../assets/less/mixin.less";
.income-box {
  position: relative;
  .income-time-select {
    width: 2.6rem;
    font-family: PingFang-SC-Medium;
    font-size: 0.24rem;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0rem;
    color: #ffffff;
    text-align: right;
    position: absolute;
    right: 0.3rem;
    top: 0.32rem;
    .this-time {
      span {
        font-size: 0.2rem;
        display: inline-block;
        img {
          width: 0.2rem;
        }
      }
    }
  }
  .income-top {
    display: flex;
    margin-top: -3.5rem;
    .top-left {
      width: 3.41rem;
      height: 1.04rem;
      border-right: 1px solid rgba(255, 255, 255, 0.6);
      .this-p {
        font-family: PingFang-SC-Medium;
        font-size: 0.3rem;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0rem;
        color: #ffffff;
        padding-left: 1rem;
        padding-bottom: 0.15rem;
      }
    }
    .top-right {
      flex: 1;
      display: flex;
      .this-img {
        width: 1.9rem;
        text-align: center;
        img {
          width: 0.77rem;
          height: 0.78rem;
          display: inline-block;
        }
      }
      .this-btn {
        display: block;
        text-align: center;
        margin-top: 0.3rem;
        width: 1.65rem;
        height: 0.51rem;
        background-color: #f3f9fe;
        border-radius: 0.06rem;
        opacity: 0.8;
        font-family: PingFang-SC-Medium;
        font-size: 0.24rem;
        font-weight: normal;
        font-stretch: normal;
        line-height: 0.51rem;
        letter-spacing: 0rem;
        color: #4570f6;
      }
    }
  }
  .income-tab {
    margin-top: 1.65rem;
    background: #fff;
    .income-ul {
      margin-top: 0.5rem;
      margin-bottom: 1.5rem;
      .income-li {
        display: flex;
        width: 6.7rem;
        height: 2.01rem;
        background-color: #fff;
        box-shadow: 0rem 0rem 0.12rem 0rem rgba(34, 138, 255, 0.22);
        border-radius: 0.06rem;
        margin: 0 auto;
        margin-bottom: 0.35rem;
        .left-img {
          width: 1.8rem;
          margin-top: 0.5rem;
          img {
            display: inline-block;
            width: 1.33rem;
            height: 0.93rem;
          }
        }

        .center-p-box {
          width: 3.75rem;
          margin-top: 0.4rem;
          .center-p {
            font-family: PingFang-SC-Medium;
            font-size: 0.24rem;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0.01rem;
            color: #333333;
            padding-bottom: 0.25rem;
          }
        }
        .right-img {
          margin-top: 0.14rem;
          flex: 1;
          img {
            width: 0.9rem;
            height: 0.9rem;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/income.vue